<template>
  <!-- <component :is="type" v-bind="linkProps(to)">
    <slot />
  </component> -->
  <div @click="goPath(to, route)">
    <slot />
  </div>
</template>

<script>
import { isExternal } from "@/utils/validate"

export default {
  props: {
    to: {
      type: String,
      required: true
    },
    route: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    isExternal() {
      return isExternal(this.to)
    },
    type() {
      if (this.isExternal) {
        return "a"
      }
      return "router-link"
    }
  },
  methods: {
    //旧的方式
    linkProps(to) {
      //如果是完整外部网址链接 跳转外部窗口
      if (this.isExternal) {
        return {
          href: to,
          target: "_blank",
          rel: "noopener"
        }
      }
      return {
        //如果点击相同菜单，则跳转重定向路由 否则正常跳转
        to: this.$route.fullPath === to ? { name: "redirect", params: { path: to } } : to,
        replace: this.$route.fullPath === to
      }
    },

    //新的方式点击跳转
    goPath(to, route) {
      //如果是完整外部网址链接 跳转外部窗口
      if (this.isExternal) {
        window.open(to)
        return
      }

      if (this.$route.fullPath === to) {
        this.$router.replace({ name: "redirect", params: { path: to } })
      } else if (route.name === "iframeBox") {
        this.$router.push({ path: to, query: {href: encodeURIComponent(route.meta.href)}})
      } else {
        this.$router.push({ path: to })
      }
    }
  }
}

</script>
